import { Icon } from 'pepsico-ds'
import React from 'react'
import './NoData.scss'

function NoData() {
    return (
        <div className='no-data-container'>
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                <path d="M32.0002 14H38.0002L30.0002 6L22.0002 14H28.0002V22.34L32.0002 26.34V14Z" fill="#3A3A3A" />
                <path d="M5.62027 5.61914L2.78027 8.43914L16.0003 21.6591V34.0191L10.0003 34.0391L18.0003 41.9991L26.0003 33.9991L20.0003 34.0191V25.6591L39.5603 45.2191L42.3803 42.3791L5.62027 5.61914Z" fill="#3A3A3A" />
            </svg>
            <div className='no-data-title'>No source data available for this visualization.</div>
            <div className='no-data-desc'>Adjust your filter selections to view data; other visualizations may still show results.</div>
        </div>
    )
}

export default NoData